import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_ROUTER_BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/payment'
    },
    {
      path: '/payment',
      component: () => import('@/views/payment/Index.vue'),
      meta: {
        title: 'plan',
        description: 'payment',
        name: 'payment'
      }
    },
    {
      path: '/service/:type',
      component: () => import('@/views/payment/Service.vue'),
      meta: {
        title: 'service',
        description: 'service',
        name: 'service'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let query: any = to.query
  if (query.code && to.meta.name === 'payment') {
    let queryObj = {} as any
    queryObj = JSON.parse(decodeURIComponent(atob(query.code)))
    if (queryObj) {
      // 存储桌面端拼接参数
      sessionStorage.setItem('userInfo', JSON.stringify(queryObj))
    }
  }
  next()
})

router.afterEach(to => {
  const descriptionTag: any = document.querySelector('meta[name="description"]')
  if (descriptionTag) descriptionTag.content = to.meta.description || 'viaim'
})

export default router
